import { format } from "url";
import { environment } from "../../../environments/environment";
import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";
import { SettingGrid, createGridConfig, gridDetail, gridEditable, gridMultiple, gridSimple } from "./gridSettings/gridSettings";

const colonneSoggetto = [
  {
    dataField: 'ragioneSociale',
    dataType: 'string',
    caption: 'Ragione sociale',
    allowEditing: true,
    colWidth: '300',
  },
  {
    dataField: 'codiceFiscale',
    dataType: 'string',
    caption: 'Codice Fiscale',
    colWidth: '110',
    type: 'campo',
  },
  {
    dataField: 'partitaIva',
    dataType: 'string',
    colWidth: '110',
    caption: 'Partita Iva',

    type: 'campo',
  },
  {
    dataField: 'comune',
    colWidth: '240',
    caption: 'Località',
    type: 'campo',
    dataType: 'string',
  },
  {
    dataField: 'indirizzo',
    colWidth: '210',
    caption: 'Indirizzo',
    type: 'campo',
    dataType: 'string',
  },
]

const colonneSede = [
  /*  {
     dataField: 'tipoAttività',
     dataType: '',
     caption: '',
     allowEditing: true,
     colWidth: '60',
   }, */
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '200',
  },
  {
    dataField: 'comune',
    dataType: '',
    caption: 'Località',
    allowEditing: true,
    colWidth: '100',
  },
  {
    dataField: 'indirizzo',
    dataType: '',
    caption: 'Indirizzo',
    allowEditing: true,
    colWidth: '100',
  },
]

const colonneImballo = [

  {
    type: 'campo', class: "", dataField: "descrizione", dataType: "",
    caption: "Descrizione",
    maxLength: '60',
    width: '',
    colWidth: '450',
    validation: [{ type: "required", message: "Campo Obbligatorio" },],
  },
  {
    type: 'campo', dataField: "tipoImballo",
    dataType: "", caption: "Tipo Imballo",
    editorType: 'dxSelectBox',
    width: '',
    colWidth: '120',
    lista: {
      static: false,
      dataSource: 'tipoImballo',
      valueExpr: 'id',
      displayExpr: 'descrizione',

    },
    validation: [{ type: "required", message: "Campo Obbligatorio" },],
  }
]

const generic = [
  {
    dataField: 'id',
    dataType: '',
    caption: 'Codice',
    allowEditing: true,
    colWidth: '60'
  },
  {
    dataField: 'descrizione',
    dataType: '',
    caption: 'Descrizione',
    allowEditing: true,
    colWidth: '540'
  },
]


export const SchedaRifiutoN: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Schede descrittive rifiuto',
      titleForm: 'Scheda descrittive rifiuto',
      breadcrumbCaption: 'Schede descrittive rifiuto',
      template: 'grid',
      campoTitle: [],
      masterKey: 'id',
      service: 'SchedaRifiuto',
      api: 'SchedaRifiuto',
      filterList: '',
      filterEditor: '/$',
      formType: 'simple',
      helpDoc: 'SchedeDescrittiveRifiuti.html',
      idTabRif: [],
      queryFilter:
        [
          {
            key: 'idSchedaRifiuto',
            value: 'id'
          },
          {
            key: 'idProduttore',
            value: 'idProduttore'
          },
          {
            key: 'produttore_NostraAzienda',
            value: 'produttore_NostraAzienda'
          },
          {
            key: 'produttore_DescrizioneSoggetto',
            value: 'produttore_DescrizioneSoggetto'
          },
          {
            key: 'cerRiferimento',
            value: 'eer'
          },
        ],
      nCol: 2,
      toolbarSettings: {
        service: 'schedeRifiuti',

      }

    }

  },
  {
    itemType: "group", colCount: "4", caption: "Dati base scheda",
    groupDataField: 'datiBase',
    data: [

      {
        type: 'campo',
        colVisible: true,
        colSpan: "4",
        showInColumnChooser: true,
        allowHiding: false,
        odataType: 'string',
        odataFilter: 'contains', //>=
        dataType: "",
        class: "",
        dataField: "descrizioneScheda",
        caption: "Descrizione",
        maxLength: '60',
        acceptOnlyCharacters: environment.GENERIC_STRING,
        orderGriglia: 4,
        nCol: 10
      },

      {
        type: 'campoSpecial', dataField: "produttore_DescrizioneSoggetto", dataType: "", caption: "Produttore",
        colVisible: true,
        disableOnUpdate: true,
        width: '100',
        nCol: '5',
        orderGriglia: 5,
        colWidth: 424,
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Aziende Produttrici",
          queryString: '?TipoAttivita=P',
          componentType: 'dynamicGrid',
          related: ['nsAzienda|produttore_NostraAzienda', 'descrizione|produttore_DescrizioneSede', 'id|idProduttore', 'idSoggetto|produttore_IdSoggetto',],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Produttore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'idSoggetto', value: 'id' }
            ],
            queryString: '/$idSoggetto?$filter=(isProduttore eq true)',

          }

        }
      },
      {
        type: 'campoSpecial', dataField: "produttore_DescrizioneSede",
        dataType: "",
        caption: "U.L.",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '5',
        labelWidth: 85,

        /*  validation: [
           { type: 'required', message: 'Produttore obbligatorio' }
         ], */
        dynamic: {
          dataSource: "sede",
          service: 'sede',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Unica locali di produzione",
          costantValue: [{
            key: 'produttore_IdSoggetto',
            value: 'produttore_IdSoggetto'
          }],
          queryString: '/$produttore_IdSoggetto?$filter=(isProduttore eq true)',
          componentType: 'dynamicGrid',
          related: ['nsAzienda|produttore_NostraAzienda', 'id|idProduttore'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Selezione Unità Locale',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),



        }
      },
      {
        type: 'campo',
        dataField: "produttore_NostraAzienda",
        dataType: "boolean",
        caption: "",
        colVisible: false,
        labelVisible: false,
        editorType: 'dxCheckBox',
        disabled: true,
        disableOnUpdate: true,
        showInColumnChooser: false,
      },
      { type: 'empty', showInColumnChooser: false, dataField: '', dataType: '', colVisible: false },


      /**Dati Rifiuto */
      { type: 'empty', caption: ' ', colSpan: 4 },

      {
        type: 'campoSpecial', colVisible: true, dataField: "eer",
        colWidth: '66',
        nCol: '3',
        width: '40',
        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        showClearButton: false,
        orderGriglia: 1,
        dynamic: {
          valueExpr: '',
          queryString: '',
          displayExpr: 'id',
          dataSource: 'cer',
          service: 'cer',
          autocomplete: true,
          filterStatic: "?$filter=(not endswith(id,'00'))",
          caption: "Lista EER",
          componentType: 'dynamicGrid',
          related: ['pericoloso|isCerPericoloso', 'descrizione|descrizioneAssegnata'],
          buttonOption: {
            text: 'Cer',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona elenco dei rifiuti EER',
            name: 'eer',
            location: 'after',
          },
          settingGrid: gridSimple


        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ],

      },
      {
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Rif.",
        colWidth: '65',
        colVisible: true,
        labelVisible: true,
        nCol: '2',
        maxLength: '10',
        width: 72,
        class: 'rif-cer',
        editorClass: 'text-uppercase',

        orderGriglia: 2,
      },
      {

        showInColumnChooser: true,
        allowHiding: true,
        acceptOnlyCharacters: environment.CHARACTERS_NUMBER_INPUT,
        type: 'campoSpecial',
        dataField: "idStatoFisico",
        dataType: "number",
        labelWidth: 76,
        showClearButton: false,
        caption: 'SF',//editorType:'dxTextBox',
        nCol: '2',
        maxLength: '1',
        width: 30,
        orderGriglia: 3,
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Stato Fisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple

        },
      },
      {
        type: 'campo', dataField: "isUrbano", dataType: "boolean", caption: "Urbano",
        colVisible: false,
        labelVisible: true,
        showInColumnChooser: false,
        editorType: 'dxCheckBox',
        nCol: 1,
        defaultValue: false,
      },
      /*  {
         type: 'empty', dataField: "isCerPericoloso", dataType: "", caption: "",
         colVisible: false,
         labelVisible: false,
         nCol: '1',
         editorType: 'dxCheckBox',
         class: 'cer-pericoloso',
         defaultValue: false,
         disabled: true,
         disableOnUpdate: true,
         showInColumnChooser: false,
       }, */
      {
        showInColumnChooser: true,
        allowHiding: true,

        type: 'campo',
        dataField: "descrizioneAssegnata",
        caption: "Desc. rifiuto",
        colSpan: '4',
        nCol: 10,
        dataType: "",
        colVisible: false,

      },
      {
        type: 'campoSpecial',
        dataField: "listaHP", caption: "Carat.Peric.",
        colVisible: true,
        colSpan: '4',
        width: '100',
        nCol: '10',
        hideOnEdit: false,
        disableOnUpdate:true,
        orderGriglia: 6,
        dynamic: {
          dataSource: 'Hp',
          service: 'generic',
          autocomplete: false,
          displayExpr: '',
          valueExpr: 'id',
          caption: "Lista Caratteristiche di Pericolo",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Caratteristiche Pericolo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Caratteristiche Pericolo',
            name: 'stoccaggio',
            location: 'after',
          },
          settingGrid: createGridConfig({

            ...gridMultiple,
            colonne: generic
          }),

        }
      },

      {
        type: 'campo',
        dataField: "caratteristicheChimiche",
        caption: "Cart.chim/fis.",
        showInColumnChooser: true,
        allowHiding: true,

        dataType: "",
        maxLength: '255',

        colVisible: false,
        colSpan: '4',
        width: '100',
        nCol: '10',
      },

      {
        type: 'campo',
        dataField: 'pesoSpecifico',
        caption: "Peso specifico",
        format: environment.PRECISION,
        colCaption: 'Peso',
        nCol: 3,
        orderGriglia: 11,
        maxLength: "7",
        colVisible: false,
        colAlignment: 'right',
        colWidth: '120',
        labelVisible: true,
        editorType: 'dxNumberBox',
        class: 'warning-qta quantita-origine',
        showInColumnChooser: true,
        allowHiding: true,

      },
      {
        showInColumnChooser: true,
        allowHiding: true,
        type: 'campoSpecial',
        dataField: 'tipoCalcolo',
        caption: "Tipo calcolo",
        class: 'tipo-calcolo',
        uppercase: true,
        placeHolder: 'P/V',
        nCol: 5,
        width: '71.8',
        colAlignment: 'center',
        colVisible: false,
        /*  patterns:"P{1}\\V{1}", 
         helpText:'Ammesse solo P:peso calcola il volume / V:volume calcola il peso', */
        maxLength: 1,
        editorType: 'dxSelectBox',
        lista: {
          dataSource: 'TipoCalcolo',
          displayExpr: 'descrizione',
          valueExpr: 'id',
          static: true,

        }
      },
      { type: 'empty', dataField: '', dataType: '', caption: '', nCol: 4 },
      { type: 'empty', dataField: '', dataType: '', caption: '' },

      {
        showInColumnChooser: true,
        type: 'campoSpecial',
        dataField: 'idImballo',
        caption: 'Tipo imballaggio',
        class: 'tipo-imballo',
        disableOnUpdate: true,
        nCol: 7,
        width: 74.6,
        colSpan: 4,
        colVisible: false,
        dynamic: {
          dataSource: 'imballo',
          service: 'imballo',
          autocomplete: false,
          valueExpr: 'id',
          displayExpr: 'descrizione',
          caption: "Lista tipi di imballaggio",
          //componentType: 'ImballiComponent',
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'idImballo',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona tipi di imballaggio',
            name: 'idImballo',
            location: 'after',

          },
          settingGrid: createGridConfig({

            ...gridEditable,
            colonne: colonneImballo
          }),



        }
      },




      {
        type: 'campoSpecial', colVisible: false, dataField: "isADR",
        showInColumnChooser: false,
        maxLength: '6',
        caption: "ADR",
        dataType: "",
        editorType: 'dxSelectBox',
        nCol: 3,
        lista: {

          dataSource: 'RadioSiNo',
          valueExpr: 'id',
          displayExpr: 'text',

          static: true,
        }
      },
      {
        showInColumnChooser: false,
        type: 'campoSpecial', colVisible: false, dataField: "idTestoAdr",
        disableOnUpdate: true,
        editorType: 'textBox',
        nCol: 'custom-testo-adr',
        caption: "Testo ADR",
        dynamic: {
          valueExpr: 'id',
          autocomplete: false,
          displayExpr: 'descrizione',
          dataSource: 'TestiAdr',
          queryString: "?$filter=eer eq '$eer'",
          service: '',
          related: ['idClasseAdr|idClasseAdr', 'idOnu|idOnu'],
          caption: "Lista Testi ADR",
          componentType: 'TestiAdrComponent',//'dynamicGrid',

          buttonOption: {
            text: 'ClasseAdr',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Testi ADR',
            name: 'Classe Adr',
            location: 'after',
          },
          settingGrid: gridSimple
        }

      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idClasseAdr",
        showInColumnChooser: false,
        maxLength: '6',
        caption: "Classe",
        labelWidth: 35,
        nCol: 15,
        showClearButton: false,
        disableOnUpdate:true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'Adr',
          service: 'generic',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista Classi ADR",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'ClasseAdr',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Classi ADR',
            name: 'Classe Adr',
            location: 'after',
          },
          settingGrid: gridSimple
        }
      },
      {
        type: 'campoSpecial', colVisible: false, dataField: "idOnu",
        showInColumnChooser: false,
        nCol: '16',
        caption: "Onu",
        showClearButton: false,
        width: '7vw',
        labelWidth: 40,
        // disableOnUpdate:true,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'onu',
          service: 'generic',
          autocomplete: true,
          caption: "Lista ONU",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Onu',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Onu',
            name: 'Onu',
            location: 'after',
          },
          settingGrid: gridSimple
        }
      },

      {
        showInColumnChooser: false,
        type: 'campoSpecial',
        dataField: "idCategoriaRaee",
        caption: "Cat.Raee",
        hideOnEdit: false,
        disableOnUpdate: true,
        dataType: "",
        width: '83',
        colVisible: false,
        nCol: 83,
        editorType: 'textBox',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: 'descrizione',
          dataSource: 'Raee',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Categorie Raee",
          componentType: 'dynamicGrid',

          buttonOption: {
            text: 'Raee',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista Raee',
            name: 'Raee',
            location: 'after',
          },
          settingGrid: gridSimple
        }

      },
      {
        type: 'campoSpecial',
        showInColumnChooser: false,
        dataField: "idTipoRaee",
        caption: "P/D",
        hideOnEdit: false,
        dataType: "",
        uppercase: true,
        colVisible: false,
        editorType: 'dxSelectBox',
        nCol: 2,
        // labelWidth: 38,
        width: '5vw',
        lista: {
          dataSource: 'tipoRaee',
          valueExpr: 'id',
          displayExpr: 'id',
          static: true,
          isDefaultOption: false
        }

      },
      { type: 'empty', dataField: "", caption: "", dataType: "", },
      { type: 'empty', dataField: "", caption: "", dataType: "", },


      { type: 'empty', caption: 'Cliente/Trasportatore/Intermediario', colSpan: '4' },


      {
        type: 'campoSpecial', dataField: "idCliente", dataType: "", caption: "Cliente",
        colVisible: false,
        showInColumnChooser: false,
        disabled: true,
        colSpan: '4',
        nCol: 10,
        dynamic: {
          dataSource: "Sede/GetAllSoggettiSedi?$filter=( iscliente eq true )  and (nsazienda eq false)",
          service: 'sede',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',

          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Cliente',
            name: 'cliente',
            location: 'after',
          },


        }
      },

      {
        type: 'campoSpecial', dataField: "contrattoDesc", dataType: "", caption: "Contratto",
        colVisible: false,
        showInColumnChooser: false,
        disabled: true,
        colSpan: 4,
        nCol: 10,
        disableOnUpdate: false,
        editorClass: 'cliente-desc',
        dynamic: {
          dataSource: "Sede/GetAllSoggettiSedi?$filter=( iscliente eq true )  and (nsazienda eq false)",
          service: 'sede',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Cliente',
            name: 'cliente',
            location: 'after',
          },


        }
      },
      {
        type: 'campoSpecial', dataField: "addebitiDesc", dataType: "", caption: "Addebiti",
        colVisible: false,
        showInColumnChooser: false,
        disableOnUpdate: false,
        disabled: true,
        colSpan: 4,
        nCol: 10,
        dynamic: {
          dataSource: "Sede/GetAllSoggettiSedi?$filter=( iscliente eq true )  and (nsazienda eq false)",
          service: 'sede',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          displayExpr: 'descrizione',
          searchExpr: 'descrizioneSoggetto',
          caption: "Lista Produttori",
          queryString: '',
          componentType: 'grid',
          enableEditor: {
            add: true,
            remove: false,
            update: true
          },
          buttonOption: {
            text: 'Zone',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Cliente',
            name: 'cliente',
            location: 'after',
          },


        }
      },


      {
        type: 'campoSpecial', dataField: "trasportatore_DescrizioneSoggetto", dataType: "", caption: "Trasportatore",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '5',
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Aziende Produttrici",
          queryString: '?TipoAttivita=T',
          componentType: 'dynamicGrid',
          related: ['id|idTrasportatore', 'idSoggetto|trasportatore_IdSoggetto', 'descrizione|trasportatore_DescrizioneSede'],
          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Trasportatore',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({
              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'trasportatore_IdSoggetto', value: 'id' }
            ],
            queryString: '/$trasportatore_IdSoggetto?$filter=(isTrasportatore eq true)',

          }

        }
      },
      {
        type: 'campoSpecial', dataField: "trasportatore_DescrizioneSede",
        dataType: "",
        caption: "U.L.",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '5',
        labelWidth: 85,

        dynamic: {
          dataSource: "sede",
          service: 'sede',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Unica locali di produzione",
          costantValue: [{
            key: 'trasportatore_IdSoggetto',
            value: 'trasportatore_IdSoggetto'

          }],
          queryString: '/$trasportatore_IdSoggetto?$filter=(isTrasportatore eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idTrasportatore'],
          buttonOption: {
            text: 'Trasportatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Unità Locale',
            name: 'trasportatore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),



        }
      },
      { type: 'empty', dataField: '', caption: '', colVisible: false },
      { type: 'empty', dataField: '', caption: '', colVisible: false },

      {
        type: 'campoSpecial', dataField: "intermediario_DescrizioneSoggetto", dataType: "", caption: "Intermediario",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '5',
        dynamic: {
          dataSource: "Soggetto",
          service: 'soggetto',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizioneSoggetto',
          caption: "Lista Aziende Produttrici",
          queryString: '?TipoAttivita=I',
          componentType: 'dynamicGrid',
          related: ['id|idIntermediario', 'idSoggetto|intermediario_IdSoggetto', 'descrizione|intermediario_DescrizioneSede'],

          buttonOption: {
            text: 'Produttori',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Selezione Intermediario',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({
              ...gridDetail,
              width: 1000,
              colonne: colonneSoggetto
            }),

          detailOption: {
            isRemote: true,
            service: "sede",
            api: "Sede",
            isEditable: false,
            colonne: colonneSede,
            costantValue: [
              { key: 'intermediario_IdSoggetto', value: 'id' }
            ],
            queryString: '/$intermediario_IdSoggetto?$filter=(isIntermediario eq true)',

          }

        }
      },
      {
        type: 'campoSpecial', dataField: "intermediario_DescrizioneSede",
        dataType: "",
        caption: "U.L.",
        colVisible: false,
        disableOnUpdate: true,
        width: '100',
        nCol: '5',
        labelWidth: 85,

        dynamic: {
          dataSource: "sede",
          service: 'sede',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'descrizione',
          caption: "Lista Unica locali di produzione",
          costantValue: [{
            key: 'intermediario_IdSoggetto',
            value: 'intermediario_IdSoggetto'

          }],
          queryString: '/$intermediario_IdSoggetto?$filter=(isIntermediario eq true)',
          componentType: 'dynamicGrid',
          related: ['id|idIntermediario'],
          buttonOption: {
            text: 'Trasportatore',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Seleziona Unità Locale',
            name: 'produttore',
            location: 'after',
          },
          settingGrid:
            createGridConfig({

              ...gridSimple,
              width: 1000,
              colonne: colonneSede
            }),



        }
      },
      { type: 'empty', dataField: '', caption: '', colVisible: false },
      { type: 'empty', dataField: '', caption: '', colVisible: false },

    ]
  },
  {
    itemType: "group", caption: "Analisi caratterizzazione rifiuto",
    groupDataField: 'datiAnalisi', colCount: '4',
    data: [

      {
        type: 'campo',
        dataField: "analisiCaratterizzazioneNumero",
        caption: "Numero",
        dataType: "",
        maxLength: '12',

        class: '',
        nCol: 33,
        colVisible: false,
      },
      {
        type: 'campoData',
        dataField: "analisiCaratterizzazioneData",
        caption: "Del",
        format: "dd/MM/yyyy",
        editorType: 'dxDateBox',
        dataType: "date",
        class: '',
        nCol: 33,
        labelWidth: 80,
        showClearButton: false,
        colVisible: false,
        showInColumnChooser: false,
        allowHiding: true,
      },
      {
        type: 'campoData',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "analisiCaratterizzazioneScadenza",
        caption: "Scadenza",
        format: "dd/MM/yyyy",
        dataType: "date",
        class: 'onu',
        nCol: 33,
        labelWidth: 80,
        editorType: 'dxDateBox',
        showClearButton: false,
        colVisible: false,

      },
      {
        type: 'empty', showInColumnChooser: false, allowHiding: true, nCol: 33,
      },

      {
        type: 'campoSpecial',
        dataField: "idRecup",
        caption: "Tip.DM 5/2/98",
        class: '',

        disableOnUpdate: true,
        nCol: 33,

        dataType: "",
        maxLength: '8',
        colVisible: false,
        dynamic: {
          costantValue: [{
            key: 'eer',
            value: 'eer'
          }],
          valueExpr: 'id',
          queryString: "?$filter=(contains(elencocer, '$eer'))",
          displayExpr: '',
          service: 'generic',
          dataSource: 'Recup',
          componentType: 'dynamicGrid',
          autocomplete: false,
          settingGrid: createGridConfig({
            ...gridSimple,
            searchAndSelect: false
          }),


          buttonOption: {
            text: 'Recup',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista elenco codici di recupero',
            name: 'Recup',
            location: 'after',
          },

        },
      },
      {
        type: 'campoSpecial',
        showInColumnChooser: false,
        dataField: "idBasilea",
        maxLength: '5',
        caption: "Reg.1013",
        editorClass: 'text-uppercase',
        class: '',
        nCol: 33,
        labelWidth: 80,
        colVisible: false,
        colWidth: 424,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          service: 'generic',
          dataSource: 'Basilea',
          componentType: 'dynamicGrid',
          autocomplete: true,
          caption: 'Lista Basilea',
          buttonOption: {
            text: 'categorie',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista dei Cer Basilea',
            name: 'categorie',
            location: 'after',
          },
          settingGrid: gridSimple,
        },
      },
      {
        showInColumnChooser: false,
        type: 'campo',
        dataField: "bod",
        caption: "B.O.D. [mg/L]",
        maxLength: '10',
        format: '########0.###',
        editorType: 'dxNumberBox',
        class: 'bod-cod',
        nCol: 33, labelWidth: 80,
        colVisible: false,


      },
      {
        showInColumnChooser: false,
        type: 'campo',
        dataField: "cod",
        caption: "C.O.D. [mg/L]",
        format: '########0.###',
        editorType: 'dxNumberBox',
        dataType: "",
        maxLength: '10',
        class: 'bod-cod',
        nCol: 33,
        labelWidth: 80,
        colVisible: false,

      },

      { type: 'empty', colSpan: '4', dataField: '', caption: ' ', colVisible: false },

      {
        type: 'campo',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "descrizioneProcessoProduttivo",
        caption: "Proc.produttivo",
        placeHolder: 'Descrizione del processo produttivo',
        colSpan: '4',
        colVisible: false,
        nCol: 10,
      },

      {
        type: 'campo',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "materiePrimeProdottiImpiegati",
        caption: "Materie prime",
        placeHolder: 'Materie prime e prodotti impiegati ',
        colSpan: '4',
        colVisible: false,
        nCol: 10,
      },

      {
        showInColumnChooser: false,
        allowHiding: true,
        type: 'campo',
        dataField: "colore",
        caption: "Colore",
        colSpan: '4',
        nCol: 10,
        colVisible: false,
      },

      {
        showInColumnChooser: false,
        allowHiding: true,
        type: 'campo',
        dataField: "odore",
        caption: "Odore",
        nCol: 10,
        colSpan: '4',
        colVisible: false,

      },

      {
        showInColumnChooser: false,
        allowHiding: true,
        type: 'campo',
        dataField: "morfologia",
        caption: "Morfologia",
        nCol: 10,
        colSpan: '4',
        colVisible: false,

      },

      {
        showInColumnChooser: false,
        allowHiding: true,
        type: 'campo',
        dataField: "quantitaPrevista",
        caption: "Qta prevista(Ton)",
        nCol: 3,
        maxLength: '18',
        colVisible: false,
        editorType: 'dxNumberBox',
        dataType: 'number',

        width: '6vw'

      },
      {
        showInColumnChooser: false,
        allowHiding: true,
        type: 'campoSpecial',
        dataField: "rifiutoProdottoRegolarmente",
        caption: "Rifiuto prod.Reg.",
        colVisible: false,
        nCol: 4,
        editorType: 'dxRadioGroup',
        radioGroup: {
          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,
          items: [

            {
              icon: 'glyphicon icon-unlocked',
              value: true,
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: false,
              descrizione: 'No',
              alignment: 'center',
            },

          ]

        }
      },
      {
        showInColumnChooser: false,
        allowHiding: true,
        type: 'campoSpecial',
        dataField: "conferimentoSpot",
        caption: "Conferimento spot",
        colVisible: false,
        editorType: 'dxRadioGroup',
        nCol: 4,
        radioGroup: {
          dataSource: '',
          valueExpr: 'value',
          displayExpr: 'descrizione',
          layout: 'horizontal',
          static: true,
          items: [
            {
              icon: 'glyphicon icon-unlocked',
              value: true,
              descrizione: 'Si',
              alignment: 'center',
            },
            {
              icon: 'glyphicon icon-locked',
              value: false,
              descrizione: 'No',
              alignment: 'center',
            },

          ]

        }
      },
      {
        type: 'empty', showInColumnChooser: false,
        allowHiding: true, dataField: '', dataType: '',
      },

      {
        type: 'campo',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "trattamentoPreliminare",
        caption: "Trat.preliminare",
        placeHolder: 'Eventuale trattamento preliminare subito dal rifiuto',
        colSpan: '4',
        nCol: 10,
        colVisible: false,

      },

      {
        type: 'campo',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "frequenzaConferimento",
        caption: "Freq.conferim.",
        colSpan: '4',
        nCol: 10,
        colVisible: false,
      },

      {
        type: 'empty', showInColumnChooser: false,
        allowHiding: true, caption: 'Campionamento rifiuto', colSpan: '4'
      },

      {
        type: 'campo',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "campionamentoNumero",
        caption: "Numero",
        labelWidth: 100,
        dataType: "",
        nCol: 3,
        maxLength: '15',
        class: '',
        colVisible: false,

      },
      {
        showInColumnChooser: false,
        allowHiding: true,
        type: 'campoData',
        dataField: "campionamentoData",
        caption: "Del",
        format: "dd/MM/yyyy",
        editorType: 'dxDateBox',
        dataType: "date",
        width: 45,
        class: 'onu',
        nCol: 3,
        labelWidth: 52,
        showClearButton: false,
        colVisible: false,
      },
      {
        type: 'campoData',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "campionamentoScadenza",
        caption: "Scadenza",

        format: "dd/MM/yyyy",
        dataType: "date",
        width: 45,
        class: 'onu',
        nCol: 3,
        labelWidth: 62,

        editorType: 'dxDateBox',
        showClearButton: false,
        colVisible: false,

      },
      {
        type: 'empty', showInColumnChooser: false,
        allowHiding: true, dataField: '', dataType: '',
      },
      /*{
        type: 'campo',
        dataField: "allegatoDocumentazione",
        caption: "Alleg.scheda",
        editorType:'dxCheckBox',
        colVisible: false,
        class:'onu',
      },*/
      {
        type: 'empty', showInColumnChooser: false,
        allowHiding: true, caption: 'Omologa rifiuto', colSpan: '4'
      },

      {
        type: 'campo',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "omologaNumero",
        caption: "Numero",
        labelWidth: 100,
        dataType: "",
        maxLength: '15',
        class: '',
        nCol: 3,
        colVisible: false,
      },
      {
        type: 'campoData',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "omologaData",
        caption: "Del",
        format: "dd/MM/yyyy",
        dataType: "date",
        nCol: 3,
        width: 45,
        labelWidth: 52,
        class: 'onu',
        editorType: 'dxDateBox',
        showClearButton: false,
        colVisible: false,

      },
      {
        type: 'campoData',
        showInColumnChooser: false,
        allowHiding: true,
        dataField: "omologaScadenza",
        caption: "Scadenza",
        format: "dd/MM/yyyy",
        dataType: "date",
        class: 'onu',
        nCol: 3,
        width: 45,
        labelWidth: 62,
        editorType: 'dxDateBox',
        showClearButton: false,
        colVisible: false,

      },


      {
        type: 'empty', showInColumnChooser: false,
        allowHiding: true, dataField: '', dataType: '',
      },
      /*{
        type: 'campoSpecial',
        editorType: 'dxTagBox',
        dataField: "listaHP",
        caption: "Carat.di pericolo",

        odataFilter:'=',
        odataType:'string',

        dataType: "",
        width: '25vw',
        hideOnEdit: false,
        colSpan: '1',
        disableOnUpdate: true,
        colVisible: false,
        tagBoxList: {
          dataSource: 'Hp',
          valueExpr: 'id',
          displayExpr: 'id',
          showSelectionControls: true,
          maxDisplayedTags: 3

        }

      },*/
      /*{
        type: 'campoData',
        dataField: "allegatoSchedaOmologa",
        caption: "Alleg. scheda",
        format: "dd/MM/yyyy",
        dataType: "date",
        class:'onu',
        width:'5vw',
        showClearButton:false,
        colVisible: false,
        editorType:'dxCheckBox',
      },*/

    ]


  }


]

export const SchedaRifiutoLavorazione2222: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Schede Lavorazione rifiuti',
      titleForm: 'Scheda lavorazione',
      breadcrumbCaption: 'Scheda lavorazione',
      idBreadcrumbGroup: 'SchedaRifiuto',
      campoTitle: [],
      masterKey: 'id',
      service: 'SchedaRifiutoLavorazione',
      api: 'SchedaRifiutoLavorazione',
      filterList: '/$idSchedaRifiuto',
      filterEditor: '?id=$',
      formType: 'simple',
      helpDoc: '',
      startTemplate: 'gridLavorazione',
      idTabRif: [
        {
          key: 'idProduttore',
          value: 'idProduttore'
        },
        {
          key: 'IdSchedaRifiuto',
          value: 'id'

        },
      ],
      queryFilter: [],
      nCol: 1,
      toolbarSettings: {
        service: 'schedaRifiuto',
      }
    }
  },

  {
    itemType: "group", groupWidth: 700, colCount: "4", caption: "Dati EER",
    groupDataField: 'datiLavorazione',
    //LAVORAZIONE
    data: [
      // DATI SCHEDA 
      /**    DATI DELLA SCHEDA */

      {
        type: 'campoSpecial', dataField: "idSchedaRifiutoRow",
        dataType: "", caption: "Rif. Scheda",
        colVisible: true,
        showInColumnChooser: true,
        allowHiding: false,
        labelVisible: true,
        disableOnUpdate: true,
        width: '26vw',
        nCol: 10,
        colSpan: '4',
        class: 'ms-2 descrizione-cer',
        dynamic: {
          queryString: "?$filter=idProduttore gt 0 and eer ne '$cerRiferimento'",
          displayExpr: 'descrizioneScheda',
          filterStatic: "",
          dataSource: 'SchedaRifiuto',
          service: 'generic',
          autocomplete: false,
          valueExpr: 'id',
          caption: "Lista Schede Tecniche",
          componentType: 'dynamicGrid',
          related: ['eer', 'idStatoFisico', 'riferimentoEER'],
          buttonOption: {
            text: 'Schede Tecniche',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia lista Schede Tecniche',
            name: 'Cer',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,

            colonne: [
              /*{
                dataField: 'id',
                dataType: '',
                caption: ' ',
                allowEditing: false,
              },*/
              {
                dataField: 'descrizioneScheda',
                dataType: '',
                caption: 'Descrizione Scheda',
                allowEditing: false,
              },
            ],

          }),



        },

      },


      // {  type: 'empty', dataField: "", dataType: "", caption: "",},    


      //////////////////////////////////////////////
      /**Dati Rifiuto */
      {
        type: 'campoSpecial',
        colVisible: true, dataField: "eer",
        colWidth: '110',
        orderGriglia: 7,
        width: '4.688vw',
        maxLength: '6',
        caption: "EER",
        nCol: 3,
        labelWidth: 98,
        disableOnUpdate: false,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista EER",
          related: ['descrizione|descrizioneCer', 'pericoloso|isCerPericoloso'],

        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ],

      },
      {
        type: 'campo', dataField: "isCerPericoloso", dataType: "", caption: "",
        colVisible: false,
        nCol: 1,
        labelVisible: false,
        editorType: 'dxCheckBox',
        class: 'cer-pericoloso',
        defaultValue: false,
        disabled: true,
        disableOnUpdate: true
      },
      {
        type: 'campoSpecial', dataField: "descrizioneCer", dataType: "", caption: "EER.",
        colVisible: false,
        labelVisible: false,
        disableOnUpdate: true,
        width: '26vw',
        nCol: 6,
        class: 'ms-2 descrizione-cer',
        dynamic: {
          queryString: '',
          displayExpr: 'descrizione',
          filterStatic: "?$filter=(not endswith(id,'00'))",
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          caption: "Lista EER",
          componentType: 'dynamicGrid',
          related: ['id|eer', 'pericoloso|isCerPericoloso'],

          buttonOption: {
            text: 'EER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia lista EER',
            name: 'Cer',
            location: 'after',
          },
          settingGrid: gridSimple,

        },

      },
      { type: 'empty', dataField: "", dataType: "", caption: "", },

      /*{
        type:'campoSpecial', colVisible: true, dataType:'', caption:'Tipo',
        editorType:'dxSelectBox',
        colSpan:'4',
        width: '8vw',
        lista:{
          dataSource:'',
          valueExpr:'id',
          displayExpr:'descrizione',
          static:true,
          items:[
            {id:'EER',descrizione:'Rifiuto EER'},
            {id:'Articolo',descrizione:'Codice articolo'},
          ]
        }
      },*/
      /*
      {
        type: 'campoSpecial', colVisible: true, dataField: "cer",
        colWidth: '110',
        orderGriglia: 7,
        width: '4.688vw',
        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          autocomplete:false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista EER",
          related: ['descrizione|descrizioneCer', 'pericoloso|isCerPericoloso'],
         
        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ]
      },
      */
      /*
       {
         type: 'campoSpecial', dataField: "descrizioneCer", dataType: "", caption: "EER.",
         colVisible: false,
         labelVisible: false,
         disableOnUpdate: true,
         width:'27vw',
         class: 'ms-2 descrizione-cer',
         dynamic: {
           queryString: '',
           displayExpr: 'descrizione',
           filterStatic: "?$filter=(not endswith(id,'00'))",
           dataSource: 'cer',
           service: 'cer',
           autocomplete:false,
           checkValue: {
             checkValueMessage: '',
             forceInsert: false
           },
           valueExpr: '',
           caption: "Lista EER",
           componentType: 'dynamicGrid',
           related: ['id|cer', 'pericoloso|isCerPericoloso'],
          
           buttonOption: {
             text: 'EER',
             icon: 'glyphicon mdi mdi-playlist-plus',
             hint: 'Sfoglia lista EER',
             name: 'Cer',
             location: 'after',
           },
           settingGrid: {
             masterKey: 'id',
             keyUnique: 'id',
             mode: 'cell',
             selectionMode:'sigle',
             remoteOperations: true,
             hoverStateEnabled: true,
             rowAlternationEnabled: true,
             repaintChangesOnly: true,
             allowUpdating: false,
             allowDeleting: false,
             allowAdding: false,
             height: 630,
             showColBlank: false,
             colonne: [
              
                {
                 dataField: 'id',
                 dataType: '',
                 caption: 'id',
                 allowEditing: false,
               }, 
               {
                 dataField: 'descrizione',
                 dataType: '',
                 caption: 'descrizione',
                 allowEditing: false,
               },
               
 
             ]
 
           },
 
         },
 
       },
       */

      {
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Rif.EER",
        class: 'me-2',
        nCol: 35,
        labelWidth: 98,
        colVisible: true,
        labelVisible: true,
        maxLength: '10',
        width: 60,
        orderGriglia: 8,
      },

      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "S.F.",
        width: 3 + 'vw',
        colVisible: true,
        labelVisible: true,
        colWidth: "100px",
        nCol: 2,
        labelWidth: 41,
        orderGriglia: 9,
        class: 'stato-fisico',
        showClearButton: false,
        maxLength: '2',
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          related: ['descrizione|descrizione_idStatoFisico'],
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista StatoFisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple,

        },
      },

      {
        type: 'campo',
        dataField: "descrizione_idStatoFisico",
        width: '18vw',
        dataType: "",
        colVisible: false,
        labelVisible: false,
        nCol: 5,
        disableOnUpdate: true,
        disabled: true,
        readonly: true,
        showInColumnChooser: false,
        dynamic: {
          queryString: '',
          displayExpr: 'descrizione',
          filterStatic: '',
          dataSource: 'StatoFisico',
          service: '',
          autocomplete: false,
          valueExpr: '',

        },

      },
      { type: 'empty', dataField: "", dataType: "", caption: "", },
      /*   { type: 'empty', dataField: "", dataType: "", caption: "", },
   */


      /*{ 
        type: 'campo', dataField: "idStatoFisico", dataType: "",caption:'SF',editorType:'dxTextBox',
        patterns:'^[0-9]+$',width:4+'vw', 
        colSpan:'1',
        validation: [
        { type: "required", message: "Stato Obbligatorio" },

      ],
      },*/
      //{  type: 'empty', dataField: "", dataType: "", caption: "",},    
      {
        type: 'campo', dataField: "idCausaleRifiutoCopia", dataType: "", caption: "Causale",
        colVisible: true,
        hideOnEdit: true,
        colSpan: 4,
        lookup: {
          wingap: true,
          dataSource: 'CausaleRifiuti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
        }

      },
      {
        type: 'campoSpecial', dataField: "idCausaleRifiuto", dataType: "", caption: "Causale rifiuti",
        colSpan: 4,
        colVisible: false,
        labelVisible: true,
        orderGriglia: 9,
        disableOnUpdate: true,
        labelWidth: 98,
        class: 'd-none',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'CausaleRifiuti',
          related: ['descrizione|causaleRifiuto', 'id|idCausaleRifiutoCopia'],
          autocomplete: false,

        },
      },

      {
        type: 'campoSpecial', dataField: "causaleRifiuto", dataType: "", caption: "Causale rifiuti",
        validation: [
          { type: 'required', message: 'Causale Obbligatoria' }
        ],
        labelWidth: 98,
        colVisible: false,
        labelVisible: true,
        orderGriglia: 9,
        disableOnUpdate: true,
        colSpan: '4',
        nCol: 10,
        width: 33 + 'vw',
        dynamic: {
          valueExpr: '',

          displayExpr: 'descrizione',
          dataSource: 'CausaleRifiuti',
          service: '',
          related: ['id|idCausaleRifiuto'],
          queryString: "?$filter=(idOperazione eq 'A1' or  idOperazione eq 'A2') and prodottoDaGestione eq 'S'",
          autocomplete: false,
          caption: "Lista Causali Rifiuti",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Causale Rifiuto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia lista Causaloi Rifiuti',
            name: 'CausaleRifiuto',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,

            colonne: [
              {
                dataField: 'idOperazione',
                dataType: '',
                caption: ' ',
                allowEditing: false,
              },
              {
                dataField: 'descrizione',
                dataType: '',
                caption: 'descrizione',
                allowEditing: false,
              },
            ],

          }),



        },
      },


      {
        type: 'campo', dataField: "operazioneRDCopia", dataType: "", caption: "Smaltimento",
        colVisible: true,
        hideOnEdit: true,
        colSpan: 4,
        lookup: {
          wingap: true,
          dataSource: 'OperazioneSmaltimento',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          showClearButton: false,
        }

      },

      {
        type: 'campoSpecial',
        dataField: "operazioneRD",
        dataType: "",
        caption: "Op. Smaltimento",
        colVisible: false,
        labelVisible: true,
        width: '8vw',
        labelWidth: 98,
        nCol: 3,
        disableOnUpdate: true,
        showInColumnChooser: false,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          service: 'generic',
          autocomplete: false,

          valueExpr: 'id',
          displayExpr: '',
          caption: "Lista Operazioni Smaltimento e Recupero",
          queryString: '',
          filter: '',
          componentType: 'dynamicGrid',
          related: ['id|operazioneRDCopia', 'descrizione|opRdDesc'],
          enableEditor: {
            add: true,
            remove: true,
            update: true
          },
          buttonOption: {
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: gridSimple,


        }
      },
      {
        type: 'campo',
        dataField: "opRdDesc",
        width: '25.1vw',
        dataType: "",
        colVisible: false,
        labelVisible: false,
        nCol: 7,
        disableOnUpdate: true,
        disabled: true,
        readonly: true,
        showInColumnChooser: false
      },
      { type: 'empty', dataField: "", dataType: "", caption: "" },
      { type: 'empty', dataField: "", dataType: "", caption: "" },


      {
        type: 'campoSpecial', dataField: "idMagazzinoRifiuto", dataType: "", caption: "Magazzino",
        width: 17 + 'vw',
        colSpan: '4',
        nCol: 10,
        labelWidth: 98,
        editorType: 'dxSelectBox',
        colVisible: false,
        labelVisible: true,
        disableOnUpdate: false,
        lista: {
          dataSource: 'magazzinoRifiuti',
          valueExpr: 'id',
          displayExpr: 'descrizione',
          queryString: '?idSede=$idProduttore',
          static: false
        }
      },


      {
        type: 'campo', dataField: "percentuale",
        format: "#,##0.00",
        colWidth: "150px",
        colAlignment: 'right',
        dataType: "",
        editorType: 'dxNumberBox',
        caption: "Percentuale",
        width: '8vw',
        maxLength: 3,
        nCol: 34,
        min: 0,
        max: 100,
        labelWidth: 98,

      },

      {
        type: 'campoSpecial',
        colVisible: false,
        dataField: "idProduttore",
        caption: "Produttore",
        // produtto in scheda lavorazione
        class: 'd-none',//'d-none',
        colSpan: '4',
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'Sede?id=',
          autocomplete: false,
          componentType: '',
          related: ['id|idProduttore'],

        }

      },
      // {  type: 'empty', dataField: "", dataType: "", caption: ""}, 
      /*{
        type: 'campoSpecial', colVisible: false, dataField: "listaOperazioniRD",
        labelVisible: false,
        dataType: "",
        class: 'd-none',
        colSpan:'4',
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          autocomplete:false,
          valueExpr: 'id',
          displayExpr: '',
          related: ['id|listaOperazioniRDDesc'],
        }

      },*/

      /* {
         type: 'campoSpecial', colVisible: false, dataField: "operazioneRD",
         labelVisible: false,
         dataType: "",
         class: 'd-none',
         colSpan:'4',
         disableOnUpdate: true,
         dynamic: {
           dataSource: 'OperazioneSmaltimento',
           autocomplete:false,
           valueExpr: 'id',
           displayExpr: '',
           related: ['descrizione|listaOperazioniRDDesc'],
         }
 
       },*/



      /* {
        type: 'campoSpecial', colVisible: false, dataField: "Magazzino rifiuti",
       
        dataType: "",
        colSpan:'4',
        disableOnUpdate: true,
        dynamic: {
          dataSource: 'OperazioneSmaltimento',
          autocomplete:false,
          valueExpr: 'id',
          displayExpr: '',
          related: ['id|listaOperazioniRDDesc'],
        }

      }, */
    ]
  },



]

export const SchedaRifiutoMiscelazione222: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Schede miscelazione',
      titleForm: 'Scheda miscelazione',
      breadcrumbCaption: 'Scheda miscelazione',
      idBreadcrumbGroup: 'SchedaRifiuto',
      campoTitle: [],
      masterKey: 'id',
      service: 'SchedaRifiutoMiscelazione',
      api: 'SchedaRifiutoMiscelazione',
      filterList: '/$idSchedaRifiuto',
      filterEditor: '?id=$',
      formType: 'simple',
      helpDoc: '',
      idTabRif: [
        {
          key: 'idProduttore',
          value: 'idProduttore'
        },
        {
          key: 'IdSchedaRifiuto',
          value: 'id'

        },
      ],
      queryFilter: [],
      nCol: 1,
      startTemplate: 'gridMiscelazione',
      toolbarSettings: {
        service: 'schedaRifiuto',
      }
    },
  },
  {
    itemType: "group", groupWidth: 700, colCount: "4", caption: "Dati EER", groupDataField: 'datiLavorazione',
    data: [
      {
        type: 'campoSpecial', dataField: "idSchedaRifiutoRow",
        dataType: "", caption: "Rif. Scheda",
        colVisible: true,
        showInColumnChooser: true,
        allowHiding: false,
        labelVisible: true,
        disableOnUpdate: true,
        width: '26vw',
        nCol: 10,
        colSpan: '4',
        class: 'ms-2 descrizione-cer',
        dynamic: {
          queryString: "?$filter=idProduttore gt 0 and eer ne '$cerRiferimento'",
          displayExpr: 'descrizioneScheda',
          filterStatic: "",
          dataSource: 'SchedaRifiuto',
          service: 'generic',
          autocomplete: false,
          valueExpr: 'id',
          caption: "Lista Schede Tecniche",
          componentType: 'dynamicGrid',
          related: ['eer', 'idStatoFisico', 'riferimentoEER'],
          buttonOption: {
            text: 'Schede Tecniche',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia lista Schede Tecniche',
            name: 'Cer',
            location: 'after',
          },
          settingGrid: createGridConfig({
            ...gridSimple,

            colonne: [
              /*{
                dataField: 'id',
                dataType: '',
                caption: ' ',
                allowEditing: false,
              },*/
              {
                dataField: 'descrizioneScheda',
                dataType: '',
                caption: 'Descrizione Scheda',
                allowEditing: false,
              },
            ],

          }),



        },

      },

      {
        type: 'campoSpecial',
        colVisible: true, dataField: "eer",
        colWidth: '110',
        orderGriglia: 7,
        width: '4.688vw',
        maxLength: '6',
        caption: "EER",
        nCol: 3,
        labelWidth: 98,
        disableOnUpdate: false,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          caption: "Lista EER",
          related: ['descrizione|descrizioneCer', 'pericoloso|isCerPericoloso'],

        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ],

      },
      {
        type: 'campo', dataField: "isCerPericoloso", dataType: "", caption: "",
        colVisible: false,
        nCol: 1,
        labelVisible: false,
        editorType: 'dxCheckBox',
        class: 'cer-pericoloso',
        defaultValue: false,
        disabled: true,
        disableOnUpdate: true
      },
      {
        type: 'campoSpecial', dataField: "descrizioneCer", dataType: "", caption: "EER.",
        colVisible: false,
        labelVisible: false,
        disableOnUpdate: true,
        width: '26vw',
        nCol: 6,
        class: 'ms-2 descrizione-cer',
        dynamic: {
          queryString: '',
          displayExpr: 'descrizione',
          filterStatic: "?$filter=(not endswith(id,'00'))",
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          checkValue: {
            checkValueMessage: '',
            forceInsert: false
          },
          valueExpr: '',
          caption: "Lista EER",
          componentType: 'dynamicGrid',
          related: ['id|eer', 'pericoloso|isCerPericoloso'],

          buttonOption: {
            text: 'EER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia lista EER',
            name: 'Cer',
            location: 'after',
          },
          settingGrid: gridSimple,


        },

      },
      { type: 'empty', dataField: "", dataType: "", caption: "", },

      {
        type: 'campo', dataField: "riferimentoEER", dataType: "", caption: "Rif.EER",
        class: 'me-2',
        nCol: 35,
        labelWidth: 98,
        colVisible: true,
        labelVisible: true,
        maxLength: '10',
        width: 60,
        orderGriglia: 8,
      },

      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "S.F.",
        width: 3 + 'vw',
        colVisible: true,
        labelVisible: true,
        colWidth: "100px",
        nCol: 2,
        labelWidth: 41,
        orderGriglia: 9,
        class: 'stato-fisico',
        showClearButton: false,
        maxLength: '2',
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ],
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          related: ['descrizione|descrizione_idStatoFisico'],
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista StatoFisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple,

        },
      },

      {
        type: 'campo',
        dataField: "descrizione_idStatoFisico",
        width: '18vw',
        dataType: "",
        colVisible: false,
        labelVisible: false,
        nCol: 5,
        disableOnUpdate: true,
        showInColumnChooser: false,
        dynamic: {
          queryString: '',
          displayExpr: 'descrizione',
          filterStatic: '',
          dataSource: 'StatoFisico',
          service: '',
          autocomplete: false,
          valueExpr: '',

        },

      },
      { type: 'empty', dataField: "", dataType: "", caption: "", },

      {
        type: 'campo', colSpan: '4', dataField: "percentuale",
        format: "#,##0.00",
        nCol: 3,
        dataType: "", editorType: 'dxNumberBox', caption: "Percentuale",
        width: '8vw',
        min: 0,
        labelWidth: 98,
        max: 100,
        maxLength: 3,
      },
    ]
  },



]

/*backup 15/03/2024*/


export const SchedaRifiutoLavorazione: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Schede Lavorazione rifiuti',
      titleForm: 'Scheda lavorazione rifiuti',
      breadcrumbCaption: 'Scheda lavorazione',
      idBreadcrumbGroup: 'SchedaRifiuto',
      campoTitle: [],
      masterKey: 'id',
      service: 'SchedaRifiutoLavorazione',
      api: 'SchedaRifiutoLavorazione',
      filterList: '/$idSchedaRifiuto',
      filterEditor: '?id=$',
      formType: 'simple',
      helpDoc: '',
      startTemplate: 'gridLavorazione',
      idTabRif: [
        {
          key: 'id',
          value: 'idSchedaRifiuto'

        },
      ],
      queryFilter: [{
        key: 'id',
        value: 'idSchedaRifiuto'

      },],
      nCol: 1,
      toolbarSettings: {
        service: 'schedaRifiuto',
      }
    }
  },

  {
    itemType: "group", groupWidth: 700, colCount: "4", caption: "Dati EER",
    groupDataField: 'datiLavorazione',
    //LAVORAZIONE
    data: [
      /*  {
         type: 'campoSpecial', dataField: "idSchedaRifiutoRow",
         dataType: "", caption: "Rif. Scheda",
         colVisible: true,
         showInColumnChooser: true,
        
         labelVisible: true,
         disableOnUpdate: true,
         nCol:10,
         colSpan:'4',
         dynamic: {
           queryString: "?$filter=idProduttore gt 0 and eer ne '$cerRiferimento'",
           displayExpr: 'descrizioneScheda',
           filterStatic: "",
           dataSource: 'SchedaRifiuto',
           service: 'generic',
           autocomplete:false,
           valueExpr: 'id',
           caption: "Lista Schede Tecniche",
           componentType: 'dynamicGrid',
           related:['eer','idStatoFisico','riferimentoEER'],
           buttonOption: {
             text: 'Schede Tecniche',
             icon: 'glyphicon mdi mdi-playlist-plus',
             hint: 'Sfoglia lista Schede Tecniche',
             name: 'Cer',
             location: 'after',
           },
           settingGrid: createGridConfig({
             ...gridSimple,
 
             colonne: [
             
               {
                 dataField: 'descrizioneScheda',
                 dataType: '',
                 caption: 'Descrizione Scheda',
                 allowEditing: false,
               },
             ],
 
           }),
 
 
 
         },
 
       }, */

      {
        type: 'campoSpecial',
        colVisible: true,
        dataField: "eer",
        colWidth: '110',
        orderGriglia: 7,
        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        showClearButton: false,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          filterStatic: "?$filter=(not endswith(id,'00'))",
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          autocomplete: false,
          caption: "Lista EER",
          componentType: 'NicaDataGridComponent',
          buttonOption: {
            text: 'Codici CER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista codici CER',
            name: 'CodiciCERLista',
            location: 'after',
          },
          settingGrid: gridSimple


        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ]
      },

      {
        type: 'campo', dataField: "riferimentoEER", dataType: "",
        caption: "Rif.EER",
        colWidth: '100',
        width: '100',
        colVisible: true,
        labelVisible: true,
        maxLength: '10',
        orderGriglia: 8,

      },

      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "SF",
        colWidth: '50',
        colVisible: true,
        labelVisible: true,
        orderGriglia: 9,
        showClearButton: false,
        maxLength: '1',

        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Stati Fisici',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista Stati Fisici',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple
        },
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ]
      },

      {
        type: 'campoSpecial', dataField: "causaleRifiuto_Descizione", dataType: "", caption: "Causale rifiuti",
        colVisible: true,
        labelVisible: true,
        orderGriglia: 9,
        disableOnUpdate: true,
        colWidth: '400',
        showClearButton: false,
        dynamic: {
          valueExpr: '',
          queryString: "?$filter=(idOperazione eq 'A1' or  idOperazione eq 'A2') and prodottoDaGestione eq 'S'",
          displayExpr: 'descrizione',
          service: '',
          dataSource: 'CausaleRifiuti',
          autocomplete: false,
          componentType: 'NicaDataGridComponent',
          caption: 'Causali con Prodotto da gestione',
          related: ['id|idCausaleRifiuto'],
          buttonOption: {
            text: 'StatoFisico',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Lista StatoFisico',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: createGridConfig(
            {
              ...gridSimple,
              colonne: [

                {

                  dataField: 'idOperazione',
                  dataType: '',
                  caption: 'Operazione',
                  allowEditing: false,
                  groupIndex: 0,
                  colSpan: 2,
                  lista: {

                    dataSource: 'OperazioneCausaleRIfiuti',
                    valueExpr: 'id',
                    displayExpr: 'descrizione',
                  },
                },


                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: '500',
                  hideOnEdit: false
                },


              ]

            }

          )

        },
        validation: [
          { type: 'required', message: 'Causale obbligatoria' }
        ]
      },
      {
        type: 'campoSpecial',
        dataField: "operazioneRD",
        dataType: "",
        caption: "Op.",
        colVisible: true,
        labelVisible: true,
        colWidth: '70',
        disableOnUpdate: true,
        showInColumnChooser: false,
        showClearButton: false,

        dynamic: {

          dataSource: 'OperazioneSmaltimento',
          service: 'generic',
          autocomplete: false,
          valueExpr: '',
          displayExpr: 'id',
          caption: "Lista Operazioni Smaltimento e Recupero",
          queryString: '',
          filter: '',
          componentType: 'NicaDataGridComponent',
          //related: ['id|operazioneRD'],

          buttonOption: {
            text: 'Modalità di Stoccaggio',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Mod.Stoccaggio',
            name: 'stoccaggio',
            location: 'after',

          },
          settingGrid: gridSimple

        },
        validation: [
          { type: 'required', message: 'Operazione obbligatoria' }
        ]
      },

      {
        type: 'campoSpecial', dataField: "magazzinoRifiuto_Descizione", dataType: "", caption: "Magazzino",

        colWidth: '350',
        colVisible: true,
        labelVisible: true,
        disableOnUpdate: false,
        allowEditing: true,
        showClearButton: false,
        dynamic: {
          dataSource: 'magazzinoRifiuti',
          service: '',
          valueExpr: '',
          displayExpr: 'descrizione',
          queryString: '?idSede=$idProduttore',
          caption: "Lista Magazzini",
          related: ['id|idMagazzinoRifiuto'],
          componentType: 'NicaDataGridComponent',
          buttonOption: {
            text: 'Magazzino Rifiuto',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Magazzino rifiuti',
            name: 'MagazzinoRifiuto',
            location: 'after',

          },
          settingGrid: createGridConfig(
            {
              ...gridSimple,
              colonne: [

                {
                  dataField: 'descrizione',
                  dataType: '',
                  caption: 'Descrizione',
                  colWidth: 530,
                  allowEditing: true,
                },
              ]

            }

          )
        },
        validation: [
          { type: 'required', message: 'Magazzino obbligatorio' }
        ]
      },



      {
        type: 'campo',
        dataField: "percentuale",
        format: "##0.00",
        editorType: 'number',
        caption: "Percentuale",
        colWidth: '100',

        validation: [
          { type: 'required', message: 'Percentuale di incisione lavorata obbligatorio' }
        ]
      },

    ]
  },



]

export const SchedaRifiutoMiscelazione: AnaColumn[] = [
  {
    configuration:
    {
      titleGriglia: 'Schede miscelazione rifiuti',
      titleForm: 'Scheda miscelazione rifiuti',
      breadcrumbCaption: 'Scheda lavorazione',
      idBreadcrumbGroup: 'SchedaRifiuto',
      campoTitle: [],
      masterKey: 'id',
      service: 'SchedaRifiutoMiscelazione',
      api: 'SchedaRifiutoMiscelazione',
      filterList: '/$idSchedaRifiuto',
      filterEditor: '?id=$',
      formType: 'simple',
      helpDoc: '',
      startTemplate: 'gridMiscelazione',
      idTabRif: [

        {
          key: 'id',
          value: 'idSchedaRifiuto'

        },
      ],
      queryFilter: [{
        key: 'id',
        value: 'idSchedaRifiuto'

      },],
      nCol: 1,
      toolbarSettings: {
        service: 'schedaRifiuto',
      }
    }
  },
  {
    itemType: "group", colSpan: '8', caption: "",
    groupDataField: 'datiMiscelazione',

    data: [


      {
        type: 'campoSpecial',
        colVisible: true,

        dataField: "eer",
        colWidth: '65',
        orderGriglia: 7,
        maxLength: '6',
        caption: "EER",
        disableOnUpdate: false,
        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'cer',
          service: 'cer',
          filterStatic: "?$filter=(not endswith(id,'00'))",
          autocomplete: false,
          caption: "Lista EER",
          componentType: 'NicaDataGridComponent',
          buttonOption: {
            text: 'Codici CER',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista codici CER',
            name: 'CodiciCERLista',
            location: 'after',
          },
          settingGrid: gridSimple


        },
        validation: [
          { type: 'required', message: 'EER campo obbligatorio' }
        ]
      },

      {
        type: 'campoSpecial', dataField: "idStatoFisico", dataType: "", caption: "SF",
        colWidth: '30',
        colVisible: true,
        labelVisible: true,
        orderGriglia: 9,
        class: 'stato-fisico',
        showClearButton: false,
        maxLength: '1',

        dynamic: {
          valueExpr: 'id',
          queryString: '',
          displayExpr: '',
          dataSource: 'StatoFisico',
          service: 'generic',
          autocomplete: false,
          caption: "Lista Stati Fisici",
          componentType: 'dynamicGrid',
          buttonOption: {
            text: 'Lista Stati Fisici',
            icon: 'glyphicon mdi mdi-playlist-plus',
            hint: 'Sfoglia Lista Stati Fisici',
            name: 'StatoFisico',
            location: 'after',
          },
          settingGrid: gridSimple

        },
        validation: [
          { type: 'required', message: 'Stato fisico obbligatorio' }
        ]
      },

      {
        type: 'campo',
        dataField: "riferimentoEER",
        dataType: "dateTime",
        caption: "Rif.EER",
        colWidth: '70',
        colVisible: true,
        labelVisible: true,

        maxLength: '10',
      },

      {
        type: 'campo',
        dataField: "percentuale",
        format: "#,##0.00",
        dataType: "",
        colVisible: true,
        caption: "Incide per(%)",
        colWidth: '60',
        maxLength: '3',

        maxSize: 100
      },

      {
        type: 'campo',
        dataField: "neee",
        dataType: "",
        caption: " ",
        colWidth: '300',
        colVisible: true,
        labelVisible: true,
        allowEditing: false,
        maxLength: '10',
      },

    ]
  },]













